// extracted by mini-css-extract-plugin
export default {"reactGrid":"reactGrid--vNrPK"};